import * as React from 'react';
import { SwipeableDrawer, useMediaQuery } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from "react-i18next";
import {
  backdropStyles,
  BootstrapDialog,
  StyledDialogActions,
  StyledDialogContent,
  StyledDialogTitle,
  StyledMobileDialogActions,
  StyledMobileDialogContent,
  StylesCloseButton
} from './styles';
import Button from '../button/Button';

interface ModalProps {
    isOpen: boolean;
    onClose?: () => void;
    title?: string;
    children: React.ReactNode;
    confirmText?: string;
    showCancelBtn?: boolean;
    showCloseBtn?: boolean;
    onConfirm?: () => void;
}

export default function Modal({ isOpen, onClose, title, children, confirmText, showCancelBtn = true, showCloseBtn = true, onConfirm }: ModalProps) {
    const { t } = useTranslation();
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    if (fullScreen) {
        return (
            <React.Fragment>
              <SwipeableDrawer
                anchor="bottom"
                open={isOpen}
                onClose={onClose || (() => {})}
                onOpen={onClose || (() => {})}
                slotProps={{
                    backdrop: backdropStyles,
                }}
              >
                {title && (<StyledDialogTitle>
                  {title}
                </StyledDialogTitle>)}
                {showCloseBtn && (<StylesCloseButton
                  aria-label="close"
                  onClick={onClose}
                  disableRipple
                >
                  <CloseIcon />
                </StylesCloseButton>)}
                <StyledMobileDialogContent>
                  {children}
                </StyledMobileDialogContent>
                { confirmText && (<StyledMobileDialogActions>
                  {showCancelBtn && (<Button autoFocus variant="outlined" color="secondary" fullWidth onClick={onClose}>
                    {t('cancel')}
                  </Button>)}
                  <Button autoFocus variant="contained" color="error" onClick={onConfirm} fullWidth>
                    {confirmText}
                  </Button>
                </StyledMobileDialogActions>)}
              </SwipeableDrawer>
            </React.Fragment>
        );
    }


  return (
    <React.Fragment>
      <BootstrapDialog
        fullScreen={fullScreen}
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={isOpen}
        sx={{ height: { xs: '53%', sm: '100%' }, top: { xs: 'inherit' } }}
        slotProps={{
            backdrop: backdropStyles,
        }}
      >
        {title && (<StyledDialogTitle>
          {title}
        </StyledDialogTitle>)}
        {showCloseBtn && (<StylesCloseButton
            aria-label="close"
            onClick={onClose}
            disableRipple
        >
          <CloseIcon />
        </StylesCloseButton>)}
        <StyledDialogContent>
          {children}
        </StyledDialogContent>
        { confirmText && (<StyledDialogActions>
          {showCancelBtn && (<Button autoFocus variant="outlined" color="secondary" onClick={onClose}>
            {t('cancel')}
          </Button>)}
          <Button autoFocus variant="contained" color="error" onClick={onConfirm}>
            {confirmText}
          </Button>
        </StyledDialogActions>)}
      </BootstrapDialog>
    </React.Fragment>
  );
}
